import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { isInTheFuture } from '@app/shared/helpers/helpers';
import { Team } from '@app/shared/models/team';
import { Transfer } from '@app/shared/models/transfer';
import { CountdownPipe } from '@app/shared/pipes/countdown.pipe';
import { UploaderStatus } from '@smash-sdk/uploader';
import { ClipboardService } from 'ngx-clipboard';
import { CreateTeamDropboxOutput } from '@smash-sdk-private/transfer/01-2024';

@Component({
  selector: 'app-upload-progress',
  templateUrl: './upload-progress.component.html',
  styleUrls: ['./upload-progress.component.scss'],
  animations: [
    trigger(
      'fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('800ms', style({ opacity: '1' }))
      ]),
    ]
    )
  ],
})
export class UploadProgressComponent implements OnInit {
  @Input() dropbox?: CreateTeamDropboxOutput['dropbox'];
  @Input() progress = 0;
  @Input() totalSizeUploaded: number;
  @Input() totalSizeToUpload: number;
  @Input() speed: number;
  @Input() remainingTime: number;
  @Input() uploadMode: string;
  @Input() transfer: Transfer;
  @Input() hasPromotion: boolean;
  @Input() showDiscoverSmash: boolean;
  @Input() showMyAccount: boolean;
  @Input() selectedTeam: Team;
  @Input() isMainDomain: boolean;
  @Input() uploadStatus: UploaderStatus;

  @Output() cancelClicked: EventEmitter<boolean> = new EventEmitter();
  @Output() smashAgainClicked: EventEmitter<boolean> = new EventEmitter();

  linkCopied = false;
  fadeOut = false;
  menuExpanded = false;
  logoRatingImgPaths = [
    {
      email: {
        keyword: "UPLOADER_DONE_REVIEW",
        path: '/assets/img/trustpilot_review_smash.png',
        url: 'UPLOADER_DONE_REVIEW_URL_TRUSTPILOT'
      },
      link: {
        keyword: "UPLOADER_DONE_REVIEW",
        path: '/assets/img/trustpilot_review_smash.png',
        url: 'UPLOADER_DONE_REVIEW_URL_TRUSTPILOT'
      }
    },
    {
      email: {
        keyword: "UPLOADER_DONE_REVIEW",
        path: '/assets/img/google_review_smash.png',
        url: 'UPLOADER_DONE_REVIEW_URL_GOOGLE'
      },
      link: {
        keyword: "UPLOADER_DONE_REVIEW",
        path: '/assets/img/google_review_smash.png',
        url: 'UPLOADER_DONE_REVIEW_URL_GOOGLE'
      },
    }
  ];
  randomLogoRating: { email: { keyword: string, path: string, url: string }, link: { keyword: string, path: string, url: string } };

  constructor(
    private readonly countdownPipe: CountdownPipe,
    private clipboardService: ClipboardService,
  ) { }

  ngOnInit() {
    if (this.dropbox) {
      this.progress = 100;
    } else {
      this.randomLogoRating = this.getRandomLogoRating();
    }
  }

  getRandomLogoRating() {
    return this.logoRatingImgPaths[Math.floor(Math.random() * this.logoRatingImgPaths.length)];
  }

  get isUploadFinished(): boolean {
    return this.uploadStatus === UploaderStatus.Finished;
  }

  get link() {
    if (!!this.dropbox) {
      return `${window.location.origin}/request/${this.dropbox.id}`;
    }
    if (!!this.transfer?.transferUrl) {
      return this.transfer.transferUrl;
    }
  }

  get delay() {
    if (this.transfer?.availabilityStartDate) {
      return this.countdownPipe.transform(this.transfer.availabilityStartDate);
    }
  }

  get isSpeedDisplayable(): boolean {
    return this.speed && !isNaN(this.speed) && this.speed > 0 && this.totalSizeUploaded < this.totalSizeToUpload;
  }

  get isRemainingTimeDisplayable(): boolean {
    return this.uploadStatus === UploaderStatus.Started;
  }

  get isRemainingSizeDisplayable(): boolean {
    return this.uploadStatus === UploaderStatus.Started;
  }

  get isRemainingTimeComputing(): boolean {
    return this.uploadStatus === UploaderStatus.Starting;
  }

  get isSpeedComputing(): boolean {
    return this.uploadStatus === UploaderStatus.Starting;
  }

  onCopy() {
    this.linkCopied = true;
    this.fadeOut = true;
    setTimeout(() => this.linkCopied = false, 1500);
    setTimeout(() => this.fadeOut = false, 400);
  }

  copyLink() {
    this.clipboardService.copy(this.link);
    this.onCopy();
  }

  cancelUpload() {
    this.cancelClicked.emit(true);
  }

  makeNewSmash() {
    this.smashAgainClicked.emit(true);
  }

  expandMenu() {
    this.menuExpanded = !this.menuExpanded;
  }

  makeNewDropbox() {
    this.smashAgainClicked.emit(true);
  }
}
